let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1N1Pc")).then(() => parcelRequire('1Z6zt'));